import {useEffect} from 'react';

export function useDefaultPageTitle() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Tableaux de bord et IA';

    return () => {
      document.title = previousTitle;
    };
  }, []);
}
